<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Editar {{ title }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <v-text-field
            v-model="name"
            :error-messages="formErrors.name"
            label="Nome"
            @input="formErrors.name = ''; createSlug()"
          />
          <v-text-field
            v-model="slug"
            :error-messages="formErrors.slug"
            label="Sigla / Abreviatura"
            @input="formErrors.slug = ''"
          />
          <v-text-field
            v-model="order"
            label="Ordem"
            @input="formErrors.order = ''"
          />
          <v-select
            v-model="subject"
            :items="subjects"
            item-text="name"
            item-value="id"
            :error-messages="formErrors.grade_subject_id"
            label="Matéria"
          />
          <v-select
            v-model="volume"
            :items="volumes"
            item-text="name"
            item-value="id"
            :error-messages="formErrors.grade_volume_id"
            label="Volume"
          />
          <v-switch
            v-model="status"
            class="ma-2"
            :label="status ? 'Ativo' : 'Inativo'"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSubmit"
          >
            Salvar {{ title }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import handlesServerValidation from '@/mixins/handles-server-validation.js'
import slugify from 'slugify'
export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],
  props: {
    title: { type: String, default: undefined },
    item: { type: Object, default: undefined },
    action: {
      type: Function,
      default: () => {}
    },
    subjects: { type: Array, default: () => ([]) },
    volumes: { type: Array, default: () => ([]) }
  },
  data: () => ({
    name: '',
    slug: '',
    order: 0,
    status: false,
    subject: null,
    volume: null
  }),
  computed: {
  },
  created () {
    if (this.item) {
      this.name = this.item.name
      this.slug = this.item.slug
      this.order = this.item.order
      this.status = this.item.status
      this.subject = this.item.grade_subject_id
      this.volume = this.item.grade_volume_id
    }
  },

  methods: {
    createSlug () {
      this.slug = slugify(this.name).toLowerCase()
    },

    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      const data = {
        name: this.name,
        slug: slugify(this.slug).toLowerCase(),
        order: this.order,
        status: this.status ? 1 : 0,
        grade_subject_id: this.subject,
        grade_volume_id: this.volume
      }
      try {
        await this.action(this.item.id, data)
        this.$store.dispatch('setSnackBar', { text: `${this.title} atualizado com sucesso!`, color: 'green' })
        this.$emit('resolve', true)
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: `Não foi possível salvar o ${this.title}, tente novamente mais tarde.`, color: 'red' })
      }
    }
  }
}
</script>
